import React from 'react';
import {Button} from "@emburse/ui-core";
import {Icon, SyncIcon} from "@emburse/ui-essentials";
import {useTranslation} from "react-i18next";

interface RefreshButtonProps {
    id: string;
    enableRefreshButton: boolean;
    refreshAccountsInProgress: boolean;
    onClick: () => void;
}

export const RefreshButton: React.FC<RefreshButtonProps> = ({id, enableRefreshButton, refreshAccountsInProgress, onClick}) => {
    const {t} = useTranslation();

    return (
        <Button id={id}
                startIcon={<Icon iconUrl={SyncIcon}/>}
                size="small"
                variant="text"
                data-qa={`${id}-button`}
                sx={{minWidth: 100, maxHeight: 40}}
                disabled={!enableRefreshButton}
                isLoading={refreshAccountsInProgress}
                onClick={onClick}>
            {t('refresh')}
        </Button>
    );
};
